module.exports = __webpack_public_path__ + "static/media/bordeauP1.855abec6.png";